import padStart from "lodash/padStart";
import millisecondsToMinutes from "date-fns/millisecondsToMinutes";
import millisecondsToSeconds from "date-fns/millisecondsToSeconds";

export default function formatMillisecondsToTime(ms: number) {
  const minutes = millisecondsToMinutes(ms);
  const secondsInMinute = 60;
  const seconds = millisecondsToSeconds(ms) % secondsInMinute;
  const formattedSeconds = padStart(seconds.toString(), 2, "0");

  return `${minutes}:${formattedSeconds}`;
}
